import type { ModelFactImplReport } from '@app/api/Analytics';
import type { FactImplTableRow } from '@app/pages/Analytics/ActualImplementation/types';

export const transformActualImplementationToTableData = (
  requestData: ModelFactImplReport | undefined
): FactImplTableRow[] => {
  if (!requestData) {
    return [];
  }

  const rows = (requestData.DayRows ?? []).map((row) => ({
    ...row,
    key: row.Date,
  }));

  const totalRow: FactImplTableRow = {
    ...requestData.TotalRow,
    Date: 'Итого',
    key: 'total-row',
    isTotal: true,
  };

  return [...rows, totalRow];
};
